import React, { useState, useEffect } from 'react'
import { FetchRegisterSalesReport, FetchSalesReportDesigner } from '../../fetcher';
import { useHandleAlertMessage } from '../../utils/togglinghooks';
import AlertMessage from '../alertmessages/AlertMessageView';
import { SalesReportTableContainer } from './SalesReportTableContainer'

const SalesReportContainer = () => {
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [salesReport, setSalesReport] = useState([])
    const [options, setOptions] = useState([])

    useEffect(() => {
        FetchRegisterSalesReport(setOptions, openAlert)
    }, []);

    const loadReport = (startDate, endDate, boutiqueSysId) => {
        let requestParam = {
            "Name": options[0].Name,
            "ReportId": options[0].ReportId.toString(),
            "StartDate": startDate,
            "EndDate": endDate,
            "BoutiqueSysId": boutiqueSysId
        }
        FetchSalesReportDesigner(setSalesReport, requestParam, openAlert)
    }

    return (
        <>
            <SalesReportTableContainer salesReport={salesReport} options={options} loadReport={loadReport} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </>
    )

}

export { SalesReportContainer }